import { Box, Image } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { ImageModel } from '@models/types'

interface ImageGridItemProps {
  image: ImageModel,
}

const ImageGridItem = (props: ImageGridItemProps) => {
  const { image } = props

  const imagePayload = useImage(image)
  const {
    callbacks: { createOrEditImage },
    image: {
      square_url,
    },
  } = imagePayload

  return (
    <Box
      onClick={() => createOrEditImage()}
      style={{ cursor: 'pointer' }}
    >
      <Image
        backgroundSize="cover"
        borderRadius={5}
        boxProps={{ backgroundColor: 'backgroundColor' }}
        height={150}
        url={square_url}
      />
    </Box>
  )
}

export default ImageGridItem
